import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "./Button";
import "./styles.css";
import { useLocation } from "react-router";
import ChosenButton from "./ChosenButton";
import Description from "../common/Description";

const Header = ({
  bookingData,
  section,
  settingsData,
  setSection,
  scrollIntoView,
  setIsVisible,
  config,
  culture,
}) => {
  const [introduction, setIntroduction] = useState();
  const [newContent, setNewContent] = useState();
  const location = useLocation();

  const getText = (data) => {
    const filter =
      data.translations &&
      data?.translations?.filter((el) => el.culture === culture);
    if (filter?.[0]?.name && filter?.[0]?.name !== undefined) {
      return filter?.[0]?.name;
    } else {
      return data.name;
    }
  };

  const fileName = `${settingsData?.description}.${culture}.md`;

  useEffect(() => {
    if (!settingsData?.description) {
      setIntroduction(undefined);
      return;
    }
    axios
      .get(
        `${config.baseUrl}/ee-static/shop/${config.shopName}//Texts/${fileName}`,
        {
          headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      )
      .then((data) => setIntroduction(data.data))
      .catch((err) => {
        console.log(err);
      });
  }, [fileName, culture, config.baseUrl, config.shopName, location.pathname, settingsData?.description]);

  useEffect(() => {
    setNewContent(bookingData);
  }, [bookingData, location.pathname]);

  return (
    <>
      {newContent && newContent.length > 0 ? (
        <div
          className="articleHeaderWrapper"
          style={{
            display: newContent.length === 1 ? "none" : "block",
          }}
        >
          <div>
            <Description text={introduction} fileName={fileName} centered />
          </div>
          <div className="buttonWrapper">
            {newContent.length > 1
              ? newContent.map((el, i) => (
                  <div key={el + i}>
                    <Button
                      text={getText(el)}
                      section={section}
                      setSection={setSection}
                      data={el}
                      scrollIntoView={scrollIntoView}
                      setIsVisible={setIsVisible}
                    />
                  </div>
                ))
              : newContent.map((el, i) => (
                  <div key={el + i}>
                    <ChosenButton
                      text={el?.name}
                      section={section}
                      setSection={setSection}
                      data={el}
                      scrollIntoView={scrollIntoView}
                      setIsVisible={setIsVisible}
                    />
                  </div>
                ))}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Header;
